export const apiErrorMessage = error => {
  const message = typeof error === 'string' ? error : error?.response?.data?.message || error?.message;
  if (error?.code === 'ERR_NETWORK' || message === 'Network Error') {
    return 'Le serveur est injoignable. Vérifiez la connexion puis réessayez.';
  }
  return typeof message === 'string' && message.trim() ? message : 'Une erreur est survenue. Réessayez.';
};
